module.exports = __webpack_public_path__ + "img/law3.ee9f1b13.webp";